import React from 'react';
import PropTypes from 'prop-types';

const InputField = ({ 
  type, 
  placeholder, 
  value, 
  onChange, 
  name, 
  label,
  error,
  disabled,
  required,
  className,
  maxLength
}) => (
  <div className={`input-field ${error ? 'has-error' : ''} ${className || ''}`}>
    {label && <label htmlFor={name}>{label}</label>}
    <input
      id={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      name={name}
      disabled={disabled}
      required={required}
      maxLength={maxLength}
      style={{
        width: '100%',
        overflow: 'visible',
        textOverflow: 'clip',
        whiteSpace: 'normal',
      }}
    />
    {error && <span className="error-message">{error}</span>}
  </div>
);

InputField.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  maxLength: PropTypes.number 
};

InputField.defaultProps = {
  type: 'text',
  disabled: false,
  required: false
};

export default InputField;